import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#080B14] border-t border-white/5 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src="https://customer-assets.emergentagent.com/job_smart-roofing-2/artifacts/7ngvxkwz_2.png"
              alt="Evoluzione Tetto"
              className="h-10 w-auto mb-4"
            />
            <p className="text-sm text-gray-500 leading-relaxed">
              Divisione di Revogreen Srl. Specializzati nella manutenzione e rifacimento tetti senza ponteggi.
            </p>
          </div>

          {/* Servizi */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Servizi</h4>
            <ul className="space-y-2.5">
              <li><Link to="/lavorazioni" className="text-sm text-gray-500 hover:text-[#FF5722] transition-colors">Smaltimento Eternit</Link></li>
              <li><Link to="/lavorazioni" className="text-sm text-gray-500 hover:text-[#FF5722] transition-colors">Lamiere per Fotovoltaico</Link></li>
              <li><Link to="/lavorazioni" className="text-sm text-gray-500 hover:text-[#FF5722] transition-colors">Pannelli Coibentati</Link></li>
              <li><Link to="/lavorazioni" className="text-sm text-gray-500 hover:text-[#FF5722] transition-colors">Manutenzione Tetti</Link></li>
            </ul>
          </div>

          {/* Azienda */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Azienda</h4>
            <ul className="space-y-2.5">
              <li><Link to="/partner" className="text-sm text-gray-500 hover:text-[#FF5722] transition-colors">Partner</Link></li>
              <li><Link to="/collaborazioni" className="text-sm text-gray-500 hover:text-[#FF5722] transition-colors">Collaborazioni</Link></li>
              <li><Link to="/privacy-policy" className="text-sm text-gray-500 hover:text-[#FF5722] transition-colors">Privacy Policy</Link></li>
              <li><Link to="/cookie-policy" className="text-sm text-gray-500 hover:text-[#FF5722] transition-colors">Cookie Policy</Link></li>
            </ul>
          </div>

          {/* Contatti */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contatti</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:800864621" className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#FF5722] transition-colors">
                  <Phone className="w-4 h-4 shrink-0" />
                  800 86 46 21 (Numero Verde)
                </a>
              </li>
              <li>
                <a href="https://wa.me/393791617599" className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#FF5722] transition-colors">
                  <Phone className="w-4 h-4 shrink-0" />
                  379 161 7599 (WhatsApp)
                </a>
              </li>
              <li>
                <a href="mailto:info@revogreenitalia.com" className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#FF5722] transition-colors">
                  <Mail className="w-4 h-4 shrink-0" />
                  info@revogreenitalia.com
                </a>
              </li>
              <li>
                <div className="flex items-start gap-2 text-sm text-gray-500">
                  <MapPin className="w-4 h-4 shrink-0 mt-0.5" />
                  Via Roma 44B, Mozzecane (VR)
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/5 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-600">
            &copy; {new Date().getFullYear()} Revogreen Srl - P.IVA 04753100235. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-4 text-xs text-gray-600">
            <span>Gruppo RevoGreen:</span>
            <a href="https://www.revoultra.it" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF5722] transition-colors">RevoUltra</a>
            <span className="text-gray-800">|</span>
            <a href="https://isoliamo.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF5722] transition-colors">Isoliamo</a>
            <span className="text-gray-800">|</span>
            <a href="https://revoquota.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF5722] transition-colors">RevoQuota</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
